import http from "@/utils/http";
let qrcode = "/hrApi";

export default {
  auditAddApply: (data) =>
    http.post(`${qrcode}/scan/wx/auditAddApply`, data),

  getDetail: (data) =>
    http.post(`${qrcode}/scan/wx/auditAddApplyDetail`,data),

  ckGetDetail: (data) =>
    http.post(`${qrcode}/scan/wx/auditCkAddApplyDetail`,data),

  ckAuditAddApply: (data) =>
      http.post(`${qrcode}/scan/wx/auditCkAddApply`, data),

  scanGetDetail: (data) =>
      http.post(`${qrcode}/qrcode/warning/detail`,data),

};
